import React, { useEffect, useRef } from "react";
import Layout from "./Layout";
import useTableFunction from "../../../hooks/useTableFunction";
import { COLLECTION, SESSION } from "../../../data/constant";
import { db } from "../../../config/firebase";
import { doc, getDoc } from "firebase/firestore";

const CampusPods = () => {

const dynamicConditionCB = async () => {
  try {
    let campus = "";

    const sessionId = localStorage.getItem(SESSION.CAMPUS_SESSION_ID);

    // Check if session ID exists
    if (!sessionId) {
      console.error("Campus session ID not found in local storage.");
      return null;
    }

    // Get document reference and fetch data
    const docRef = doc(db, COLLECTION.CAMPUS_SESSION, sessionId);
    const docSnap = await getDoc(docRef);

    // Check if the document exists
    if (docSnap.exists()) {
      const data = docSnap.data();
      campus = data?.campusId;

      const camdocRef = doc(db, COLLECTION.CAMPUS, campus);
    const camdocSnap = await getDoc(camdocRef);
const camdata = camdocSnap.data()

      campus = camdata.campusId

      console.log("Campus ID fetched:", campus);

      // Validate if campus ID is not undefined or empty
      if (!campus) {
        console.error("Campus ID not found in the document.");
        return null;
      }

      return {
        column: "campus",
        operator: "==",
        query: campus,
      };
    } else {
      console.error("Campus session document does not exist.");
      return null;
    }
  } catch (error) {
    console.error("Error in dynamicConditionCB:", error.message);
    return null;
  }
};


  const {
    tableData,
    isTableLoading,
    currentPage,
    totalLength,
    handlePageChange,
    handlePageSize,
    handleSearchQuery,
    handleTableSorting,
    refetchTableData,
  } = useTableFunction({
    collectionPath: COLLECTION.POD,
    dynamicCondition: dynamicConditionCB,
  });

  return (
    <Layout
      campusPodData={tableData}
      isTableLoading={isTableLoading}
      currentPage={currentPage}
      totalLength={totalLength}
      handlePageChange={handlePageChange}
      handlePageSize={handlePageSize}
      handleSearchQuery={handleSearchQuery}
      handleTableSorting={handleTableSorting}
    />
  );
};

export default CampusPods;
